import { menuItem } from "../../css";
// ----------------------------------------------------------------------
export function menu(theme) {
    return {
        MuiMenuItem: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, menuItem(theme)), { "& .MuiListItemIcon-root": {
                        marginRight: 0,
                        minWidth: "auto",
                    } }),
            },
        },
        MuiMenu: {
            styleOverrides: {
                // root: {
                // backgroundColor: theme.palette.background.default,
                boxShadow: "-20px 20px 40px -4px #919EAB3D,0px 0px 2px 0px #919EAB3D",
                // },
                paper: {
                    boxShadow: "-20px 20px 40px -4px #919EAB3D,0px 0px 2px 0px #919EAB3D",
                    // boxShadow: 'none', // Cleaner, modern shadow
                    borderRadius: 8,
                    backgroundImage: "url(/assets/paper-bg.svg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                },
            },
        },
    };
}
